import React from 'react'
import { SIZESANDSTYLES } from '../constants';

const FontCircles = ({ selected, updateTodo }) => {

  return (
    <div className="fc-row">
      <div className="fc-group">
        <button
          key={selected?.rowID}
          className={
            "fc-circle" + (selected?.fontSizeAndStyle?.fontSize === SIZESANDSTYLES.small ? " fc-circle-active" : "")
          }
          onClick={() => updateTodo("fontSizeAndStyle", SIZESANDSTYLES.small, "fontSize")}
        >
          <span className="fc-font fc-small">a</span>
        </button>
        <button
          className={
            "fc-circle" + (selected?.fontSizeAndStyle?.fontSize === SIZESANDSTYLES.medium ? " fc-circle-active" : "")
          }
          onClick={() => updateTodo("fontSizeAndStyle", SIZESANDSTYLES.medium, "fontSize")}
        >
          <span className="fc-font fc-medium">a</span>
        </button>
        <button
          className={
            "fc-circle" + (selected?.fontSizeAndStyle?.fontSize === SIZESANDSTYLES.large ? " fc-circle-active" : "")
          }
          onClick={() => updateTodo("fontSizeAndStyle", SIZESANDSTYLES.large, "fontSize")}
        >
          <span className="fc-font fc-large">a</span>
        </button>
      </div>
      <div className="fc-group">
        <button
          className={
            "fc-circle" + (selected?.fontSizeAndStyle?.italics ? " fc-circle-active" : "")
          }
          onClick={() => updateTodo("fontSizeAndStyle", selected?.fontSizeAndStyle?.italics ? !selected.fontSizeAndStyle.italics : true, "italics")}
        >
          <span className="fc-font fc-italic">I</span>
        </button>
        <button
          className={
            "fc-circle" + (selected?.fontSizeAndStyle?.bold ? " fc-circle-active" : "")
          }
          onClick={() => updateTodo("fontSizeAndStyle", selected?.fontSizeAndStyle?.bold ? !selected.fontSizeAndStyle.bold : true, "bold")}
        >
          <span className="fc-font fc-bold">B</span>
        </button>
      </div>
    </div>
  );
}
export default FontCircles